<template lang="html">
  <section class="new-business">
    <div class="pageHeading" v-if="!modal">
      <h1 v-if="!isExisting">Create New Business</h1>
      <h1 v-else>Edit Business</h1>
    </div>



    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add Director</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field @input="directorEmailChange"  v-model="directorToAdd.email" label="Email*" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field  :disabled="directorToAdd._id != undefined" v-model="directorToAdd.firstName" label="First name*" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 >
                <v-text-field  :disabled="directorToAdd._id != undefined" v-model="directorToAdd.lastName" label="Last name*" ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4 >
                <v-text-field :disabled="directorToAdd._id != undefined" v-model="directorToAdd.phone" label="Phone*" ></v-text-field>
              </v-flex>


            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" flat @click="dialog = false" :disabled="working">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="addDirector" :disabled="!validNewDirector || working">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-card elevation="0">
    <v-list two-line style="padding: 0px">
      <v-list-tile class="mainSectionHeadingInList" @click="">
        <v-list-tile-action>
          <v-icon color="indigo">business</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Business Information</v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>
      <v-list-tile @click="">
        <v-list-tile-action>
        </v-list-tile-action>

        <v-list-tile-content>

          <v-text-field
                  v-validate="'required'"
                  v-model="businessData.name"
                  @input="updateValue"
                  label="Business Name"
                  size="30"
                  required
          ></v-text-field>
        </v-list-tile-content>
        <v-list-tile-content>

          <v-text-field
                  v-validate="'required'"
                  v-model="businessData.address"
                  @input="updateValue"
                  size="50"
                  label="Business Address"
                  required
          ></v-text-field>
        </v-list-tile-content>

      </v-list-tile>


      <v-list-tile @click="">
        <v-list-tile-action>
        </v-list-tile-action>

        <v-list-tile-content>

          <v-text-field
                  v-validate="'required'"
                  v-model="businessData.notes"
                  @input="updateValue"
                  label="Notes"
                  size="90"
                  required
          ></v-text-field>
        </v-list-tile-content>

      </v-list-tile>


      <v-list-tile class="mainSectionHeadingInList" @click="">
        <v-list-tile-action>
          <v-icon color="indigo">person</v-icon>
        </v-list-tile-action>


        <v-list-tile-content>
          <v-list-tile-title>Directors Accounts</v-list-tile-title>
          <v-list-tile-sub-title>
          </v-list-tile-sub-title>
        </v-list-tile-content>



        <v-list-tile-action>
          <v-btn @click="openAddDirector" icon ripple>
            <i class="fas fa-user-plus"></i>
          </v-btn>
        </v-list-tile-action>

      </v-list-tile>


      <v-expansion-panel>
        <v-expansion-panel-content
                v-for="(director,i) in directorList"
                :key="i"

        >
          <div slot="header">{{director.firstName}} {{director.lastName}}</div>

          <v-card>
            <v-container>
              <v-layout row wrap>

                  <v-flex xs12 md6>
              <v-text-field
                      v-validate="'required'"
                      v-model="director.email"
                      label="Account Email"
                      required
                      readonly
              ></v-text-field>
                  </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                          v-validate="'required'"
                          v-model="director.phone"
                          label="Phone"
                          required
                          readonly
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                          v-validate="'required'"
                          v-model="director.firstName"
                          label="First Name"
                          readonly
                          required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                          v-validate="'required'"
                          v-model="director.lastName"
                          label="Last Name"
                          readonly
                          required
                  ></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-list>



    </v-card>


    <br v-show="!modal"/>
    <v-divider v-show="!modal"></v-divider>
    <br v-show="!modal"/>

    <v-btn v-show="!modal" v-if="!isExisting" @click="createBusiness"
            color="primary"
    >
      Create User & Business!
    </v-btn>
    <v-btn v-else @click="updateBusiness"
           color="primary"
    >
      Update Business!
    </v-btn>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'new-business',
      props: ["modal", 'value', 'business'],
    mounted() {

       // this.newDirector()
        console.log('url query is', this.$route.name)
        if(this.isExisting)
        this.populateBusinessData(this.$route.params.id)
    },
    data() {
      return {
          working: false,
          createDirector: false,
          dialog: false,
          directorToAdd: {
          },
          directorsInSystem: [
              {
                  _id: 'test',
                  firstName: 'John',
                  lastName: 'Baird',
                  email: 'johnbaird@gmail.com',
                  phone: '234-367-2342'
              }
          ],
          businessData: {
              name: '',
              address: '',
              notes: '',
              directors: []
          }

      }
    },
    watch: {
      business: function() {
        console.log("watch business id: " + this.business)
        this.populateBusinessData(this.business);
      }
    },
    methods: {
        updateValue() {
            console.log('updatebalue', this.businessData)
            this.$emit('input', this.businessData);
        },
        directorEmailChange() {
            let foundMatch = false
            this.directorsInSystem.forEach((director)=>{
                console.log('comparting', director.email, this.directorToAdd.email, director.email == this.directorToAdd.email)
                if(director.email == this.directorToAdd.email) {
                    this.directorToAdd = director
                    foundMatch = true
                }
            })
        },
        openAddDirector() {
            this.directorToAdd = {}
            this.dialog = true

        },
        addDirector() {
          this.working = true;
            var vueThis = this
            this.$services.users.create({
                "email": vueThis.directorToAdd.email.toLowerCase().trim(),
                "password": "passwordUsedForEtcEtc",
                "firstName" : vueThis.directorToAdd.firstName,
                "lastName" : vueThis.directorToAdd.lastName,
                "invited" : true,
                "notifsRead":0,
                "phone" : vueThis.directorToAdd.phone,
                "billingAddress" : {},
                "resetToken": "",
                "permissions": ['director' ],
                "subUsers": [],
                "trips": [],
                "setup" : true,
                "disabled" : false,
                "emailVerified" : false
            }).then((result)=>{
                console.log('created director user', result)
                this.$addUser(result)
                vueThis.businessData.directors.push(result._id)
                vueThis.dialog = false
                vueThis.$emit('input', vueThis.businessData);
                vueThis.updateBusiness(false);
            }).catch(function(error){
                vueThis.$emit("alertUser","error", error.message)
            }).finally(()=>{
              vueThis.working = false;
            })

        },
        populateBusinessData(id) {
          var vueThis = this;
          if(id==null) {
            console.log('reverting')
            vueThis.businessData = {
              name: '',
              address: '',
              notes: '',
              directors: []
            }
          } else {
            this.$services.businesses.get(id).then((result) => {
              console.log('biz result is', result)
              vueThis.businessData = result
            })
          }
        },
        updateBusiness(redirect=true) {
            var vueThis = this;
            this.$services.businesses.patch(this.businessData._id, this.businessData).then((test) => {
                console.log('test update', test)

                vueThis.$emit("alertUser", "success", "Business Updated!!")
              if(redirect)
                vueThis.$router.push('/')
            }).catch(function(error){
                console.error('update Error!', error);
                vueThis.$emit("alertUser","error", "Sorry, there was an error processing your request. Please try again later.")

            });
        },
        createBusiness() {
            var vueThis = this;
            console.log('this is', this.tripData)
            this.$services.businesses.create(this.businessData).then((test) => {
                console.log('test', test)
                vueThis.$emit("alertUser", "success", "Business (" + this.businessData.name + ") Created!!")
                vueThis.$router.push('/')

            }).catch(function(error){
                vueThis.$emit("alertUser", "error", "Sorry, there was an error processing your request. Please try again later.")
                console.error('Error!', error);
            });

        },

    },
    computed: {
        validNewDirector(){
            if(this.directorToAdd.email != undefined && this.directorToAdd.email.indexOf("@") != -1 && this.directorToAdd.email.indexOf(".") != -1 && this.directorToAdd.email.length > 5 &&
            this.directorToAdd.phone.length > 9 && this.directorToAdd.firstName.length > 1 && this.directorToAdd.lastName.length > 1) {
                return true
            } else {
                return false
            }
        },
        directorList() {
            var toReturn = []
            var vueThis = this
            this.businessData.directors.forEach((director)=>{
                console.log('fetching this user from dir list', director)
                var toAdd = vueThis.$fetchUserByID(director)
                console.log('director list says', toAdd)
                if(toAdd != undefined)
                toReturn.push(toAdd)
            })
            console.log('returning', toReturn)
            return toReturn
        },
        isExisting() {
            if (this.$route.name == "updatebusiness" )
                return true;
            else
                return false;
        }

    }
}
</script>

<style scoped lang="scss">
  .new-business {

  }
</style>
